import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export interface DecryptMetadataResponse {
  authId: string;
  contactId: string;
  leadId: string;
  assetId: string;
  source: string;
}

export interface DecryptMetadataRequest {
  metaString: string;
}
  
export const decryptAndValidateApi = createApi({
  reducerPath: 'decryptAndValidateApi',
  baseQuery,
  endpoints: (builder) => ({
    decryptMetadata: builder.mutation<
      DecryptMetadataResponse,
      DecryptMetadataRequest
    >({
      async queryFn(arg, _api, _extraOptions, fetchWithBQ) {
        const decryptResult = await fetchWithBQ({
          url: `/stips/decrypt-stips-metadata/${arg.metaString}`,
          method: 'GET',
        });

        if (decryptResult.error) {
          return { error: decryptResult.error };
        }

        const decryptData =
          decryptResult.data as DecryptMetadataResponse;

        // Call validate API only when authId is present
        if (decryptData?.authId) {
          await fetchWithBQ({
            url: `/stips/validate-stip-redirect/${decryptData.authId}`,
            method: 'GET',
            params: {
              authId: decryptData.authId,
              contactId: decryptData.contactId,
              assetId: decryptData.assetId,
              leadId: decryptData.leadId,
              source: decryptData.source,
            },
          });
        }

        return { data: decryptData };
      },
    }),
  }),
});

export const { useDecryptMetadataMutation } = decryptAndValidateApi;
